import { gql } from 'graphql-request';

export const PRODUCT_COLLECTIONS = gql`
  query GetProductByHandle($handle: String!) {
    productByHandle(handle: $handle) {
      id
      title
      collections(first: 5) {
        edges {
          node {
            id
            title
            handle
          }
        }
      }
    }
  }
`;

export const PRODUCT = gql`
  query getProduct($id: ID!) {
    product(id: $id) {
      id
      title
      handle
      featuredImage {
        url
        altText
      }
      variants(first: 50) {
        edges {
          node {
            id
            title
            image {
              url
              altText
            }
          }
        }
      }
    }
  }
`;
